export interface ContactNumberData {
  type: string; // Privat, Handy, Fax, Arbeit ...
  phoneNumber: string;
  info: string;
}

export class ContactNumberData implements ContactNumberData {
  type = ''; // Privat, Handy, Fax, Arbeit ...
  phoneNumber = '';
  info = '';
  constructor(){}
}
